<script>
	import { registerPageComplete } from "../../tealium";
    import model from "../../stores/modelStore";
	import textStore from "../../stores/textStore";
    import { projectSettings, acceptedFileUploadList } from "../../config";
    import { isValid } from "../../validation";

    import PageSection from "../../components/PageSection.svelte";
    import Form from "../../components/Form.svelte";
    import FormRow from "../../components/FormRow.svelte";
    import FormColumn from "../../components/FormColumn.svelte";
    import YesNoGroup from "../../components/YesNoGroup.svelte";
    import TextInput from "../../components/TextInput.svelte";
    import TextArea from "../../components/TextArea.svelte";
    import RadioGroup from "../../components/RadioGroup.svelte";
    import RadioGroupWithImage from "../../components/RadioGroupWithImage.svelte";
    import DropZone from "../../components/DropZone.svelte";
    import MonthYearSelect from "../../components/MonthYearSelect.svelte";
    import MedicalIssues from "../../components/MedicalIssues.svelte";
    import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
    import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
    import NavigationButtons from "../../components/NavigationButtons.svelte";

    export let pageName = null;
    export let pageTitle = null;
    export let lastVisitedPage = null;
	export let persistUrl = null;
    export let disabled = null;
    
	let buttons;

    if (!disabled) {
        $model.lastPageVisited = lastVisitedPage;
        document.title = pageTitle;
    }

	const typeOfClaimOptions =[
        { 
            value: "My own claim", 
            label: "<strong>My own Claim:</strong> Living claimant (a person who themselves worked in Western Australia between 11 December 1936 to 9 June 1972 for little or no wages)?"},
        { 
            value: "Spouse claim", 
            label: "<strong>Spouse (husband/wife/partner - married or defacto) Claim:</strong> Descendant claimant (a person who is the spouse, or defacto spouse of a person who worked in Western Australia between 11 December 1936 to 9 June 1972 for little or no wages, but has passed away)? (IF YOU ARE CLAIMING IN RELATION TO MORE THAN ONE SPOUSE OR PARENT FILL IN TWO FORMS.)",
            infoLabel: "Spouse or defacto spouse means the most recent person to marry and/or be in a relationship for two or more years with the deceased person, before their death."
        },
        { 
            value: "Child claim", 
            label: "<strong>Child Claim:</strong> Descendant claimant (a person who is the child, including by traditional adoption, of a person who worked in Western Australia between 11 December 1936 to 9 June 1972 for little or no wages but has passed away)? (IF YOU ARE CLAIMING IN RELATION TO MORE THAN ONE SPOUSE OR PARENT FILL IN TWO FORMS.)",
            infoLabel: "A child means a natural child of the deceased person, or any child who was legally adopted or adopted under Aboriginal laws and customs."
        },
    ];


	const handleSubmit = async () => {
		buttons.blockNext();
        
        // clean up
        cleanSelections();

		let errors = isValid();

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(response);
			} else {
				registerPageComplete(
					pageName,
					$model.contact.emailAddress,
					$model.contact.phoneNumber,
				);
				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};

	const cleanSelections = () => {
        if ($model.claimDetail.claimType === "My own claim"){
            $model.deceased = null;
        }
	};


    //$:{
    //    console.log("TypeOfClaim", $model);
    //}

</script>

<PageSection>
	<Form id="form-typeofclaim-details" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Type of Claim</h1>
			</FormColumn>
		</FormRow>
        	

		<div class="confirmation-box-shadow">
            <FormRow>
                <FormColumn>
                    <p>
                    If you have more than one claim type to register, you will be able to add another claim at the end of this form.
                    </p>
                </FormColumn>
            </FormRow>

            <FormRow>
                <FormColumn>
                    <RadioGroup
                        required
                        {disabled}
                        orientation="vertical"
                        name="typeOfClaim"
                        label="What kind of claim are you registering for compensation money?"
                        bind:value={$model.claimDetail.claimType}
                        optionList={typeOfClaimOptions}
                        htmlLabels=true
                        />
                        
                </FormColumn>
            </FormRow>


		</div>

        
        <FormRow class="confirmation-hide">
			<FormColumn>
				<NavigationButtons bind:buttons
					nextPageLabel={$model.confirmationPage ? "Confirmation" : "Next"} />
			</FormColumn>
		</FormRow>
    </Form>
</PageSection>

<style>
    h1 {
        margin-bottom: 20px;
    }
</style>


